import { render, staticRenderFns } from "./FlexVIcon.vue?vue&type=template&id=20e289ac&"
import script from "./FlexVIcon.vue?vue&type=script&lang=js&"
export * from "./FlexVIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports